export const setSelectedSport = ( store, sport ) => {
  store.setState( { selectedSport: sport } );
  localStorage.setItem( 'selectedSport', JSON.stringify( sport ) );
};
